module.exports = __webpack_public_path__ + "static/media/card-image-vitrine.7a7e900c.jpg";